import parse from 'html-react-parser';
import { applySurveyTextRules } from '../Utilities/StringReplaceHelper';

export function parseHtml(
  text?: string | null
): ReturnType<typeof parse> | string | null | undefined {
  if (!text) {
    return text;
  }
  const value = applySurveyTextRules(text);
  return parse(value ?? '');
}
